module.exports = __webpack_public_path__ + "img/bg.72fb91a6.png";